export const updatePaymentStatus = (resp) => {
  return {
    type: 'UPDATE_PAYMENT_STATUS',
    payload: resp
  };
};


export const getOrders = (resp) => {
  return {
    type: 'FETCH_ORDERS',
    payload: resp
  };
};

export const getOrderLines = (resp) => {
  return {
    type: 'FETCH_ORDER_LINES',
    payload: resp
  };
};

export const getMerchantSignature = (resp) => {
  return {
    type: 'FETCH_MERCHANT_SIGNATURE',
    payload: resp
  };
};

export const getAllOrders = (resp) => {
    return {
        type: 'FETCH_ALL_ORDERS',
        payload: resp
    };
};

export const getAllUserOrders = (resp) => {
    return {
        type: 'FETCH_ALL_USER_ORDERS',
        payload: resp
    };
};

export const getAllBankTransfers = (resp) => {
    return {
        type: 'FETCH_ALL_BANK_TRANSFERS',
        payload: resp
    };
};

export const createPayments = (resp) => {
    return {
        type: 'CREATE_PAYMENTS',
        payload: resp
    };
};

export const getAllUsers = (resp) => {
    return {
        type: 'FETCH_USERSS',
        payload: resp
    };
};

export const getStatistiques = (resp) => {
    return {
        type: 'FETCH_STATISTIQUES',
        payload: resp
    };
};


export const paypalCallback = (resp) => {
    return {
        type: 'PAYPAL_CALLBACK',
        payload: resp
    };
};

export const getCreditNotes = (resp) => {
    return {
        type: 'FETCH_CREDIT_NOTES',
        payload: resp
    };
};

export const fetchOrderNotPayed = (resp) => {
    return {
        type: 'FETCH_ORDERS_NOT_PAYED',
        payload: resp
    };
};

export const refundCreditNote = (resp) => {
    return {
        type: 'REFUND_CREDIT_NOTE',
        payload: resp
    };
};

export const fetchTransfersNotAssociated = (resp) => {
    return {
        type: 'FETCH_TRANSFERS_NOT_ASSOCIATED',
        payload: resp
    };
};
export const deleteTransfer = (id) => {
    return {
        type: 'DELETE_TRASFER',
        payload: id
    };
};

export const deleteOrder = (id) => {
    return {
        type: 'DELETE_ORDER',
        payload: id
    };
};

export const fetchOrderNorPayedSorted = (resp) => {
    return {
        type: 'FETCH_SORTED_ORDER',
        payload: resp
    };
};

export const selectedTransfers = (resp) => {
    return {
        type: 'SELECTED_TRANSFERS',
        payload: resp
    };
};

export const calculatedSessionValidity = (resp) => {
    return {
        type: 'SESSION_VALIDITY',
        payload: resp
    };
};

export const sortedOrders = (resp) => {
    return {
        type: 'FETCH_SORTED_ORDERS',
        payload: resp
    };
};
export const selectedOrders = (resp) => {
    return {
        type: 'SELECTED_ORDERS',
        payload: resp
    };
};

export const clickButton = (resp) => {
    return {
        type: 'CLICK_BUTTON',
        payload: resp
    };
};

export const validatePayment = (resp) => {
    return {
        type: 'VALIDATE_PAYMENT',
        payload: resp
    };
};

export const setBankTransferPaginationPage = (pageNumber) => {
    return {
        type: 'SET_BANK_TRANSFER_PAGINATION_PAGE',
        pageNumber
    };
};

export const setCreditNotePaginationPage = (pageNumber) => {
    return {
        type: 'SET_CREDIT_NOTE_PAGINATION_PAGE',
        pageNumber
    };
};

export const setBankTransferPageSize = (pageSize) => {
    return {
        type: 'SET_BANK_TRANSFER_PAGE_SIZE',
        pageSize
    };
};
export const setCreditNotePageSize = (pageSize) => {
    return {
        type: 'SET_CREDIT_NOTE_PAGE_SIZE',
        pageSize
    };
};

export const setOrderPaginationPage = (pageNumber) => {
    return {
        type: 'SET_ORDER_PAGINATION_PAGE',
        pageNumber
    };
};
export const setOrderHistoryPaginationPage = (pageNumber) => {
    return {
        type: 'SET_ORDER_HISTORY_PAGINATION_PAGE',
        pageNumber
    };
};

export const setOrderPageSize = (pageSize) => {
    return {
        type: 'SET_ORDER_PAGE_SIZE',
        pageSize
    };
};
export const setOrderHistoryPageSize = (pageSize) => {
    return {
        type: 'SET_ORDER_HISTORY_PAGE_SIZE',
        pageSize
    };
};

export const searchValue = (resp) => {
    return {
        type: 'SEARCH_VALUE',
        payload: resp
    };
};

export const validatePaymentOrder = (resp) => {
    return {
        type: 'VALIDATE_PAYMENT_ORDER',
        payload: resp
    };
};
export const disabledButton = (resp) => {
    return {
        type: 'DISABLED_BUTTON',
        payload: resp
    };
};
export const setRedirectUrl = (resp) => {
    return {
        type: 'SET_URL',
        payload: resp
    };
};


export const storeIban = (selectedIban) => {
    return {
        type: 'STORE_IBAN',
        selectedIban
    }
}

export const validateIban = (resp) => {
    return {
        type: 'VALIDATE_IBAN',
        payload: resp
    };
}

export const fetchErrorCallbackURL = (resp) => {
    return {
        type: 'ERROR_CALLBACK_URL',
        payload: resp
    };
};

export const fetchModificationURL = (resp) => {
    return {
        type: 'MODIFICATION_URL',
        payload: resp
    };
};

export const fetchBackToURL = (resp) => {
    return {
        type: 'RETURN_TO_URL',
        payload: resp
    };
};

export const getMainIban = (resp) => {
    return {
        type: 'FETCH_MAIN_IBAN',
        payload: resp
    };
};

export const getOgoneKey = (resp) => {
    return {
        type: 'FETCH_OGONE_KEY',
        payload: resp
    };
};

export const fetchCreditNoteData = (resp) => {
    return {
        type: 'FETCH_CREDIT_NOTE_DATA',
        payload: resp
    };
};

export const getLatestIban = (resp) => {
    return {
        type: 'GET_LATEST_IBAN',
        payload: resp
    };
};

export const saveIban = (resp) => {
    return {
        type: 'SAVE_IBAN',
        payload: resp
    };
};

export const setBankTransferNotAssociatedPaginationPage = (pageNumber) => {
    return {
        type: 'SET_BANK_TRANSFER_NOT_ASSOCIATED_PAGE',
        pageNumber
    };
};

export const setOrderNotPayedPaginationPage = (pageNumber) => {
    return {
        type: 'SET_ORDER_NOT_PAYED_PAGE',
        pageNumber
    };
};

export const ignoreBankTransfer = (resp) => {
    return {
        type: 'IGNORE_BANK_TRANSFER',
        payload: resp
    };
};

export const saveRefundDetails = payload => {
  return {
    type: "SAVE_REFUND_DETAILS",
    payload
  };
};

export const getRefundDetails = payload => {
  return {
    type: "GET_REFUND_DETAILS",
    payload
  };
};



// WEBPACK FOOTER //
// ./app/actions/actions/payment.js